var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 318.809,
    height: 193.508,
    viewBox: "0 0 318.809 193.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slide1",
    transform: "translate(-32 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 159.405,
    cy: 4.121,
    rx: 159.405,
    ry: 4.121,
    transform: "translate(32 185.265)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M662.6,338.143H575.584v-.456a1.338,1.338,0,0,0-1.338-1.338H537.465a1.338,1.338,0,0,0-1.338,1.338v.456H448.753a5.886,5.886,0,0,0-5.886,5.886V463.18a5.886,5.886,0,0,0,5.886,5.886H662.6a5.886,5.886,0,0,0,5.886-5.886V344.029a5.886,5.886,0,0,0-5.886-5.886Z",
    transform: "translate(-332.463 -285.147)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M468.262,366a.71.71,0,0,0-.707.712V486.507a.71.71,0,0,0,.707.712h215.23a.71.71,0,0,0,.707-.712V366.712a.71.71,0,0,0-.707-.712Z",
    transform: "translate(-352.5 -307.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.152,
    cy: 2.152,
    r: 2.152,
    transform: "translate(220.882 52.464)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M635.57,643.967v-2.115c0-.116-.131-.21-.292-.21h-7.021c-.162,0-.293.094-.293.21h-4.388c0-.116-.131-.21-.293-.21h-7.021c-.162,0-.292.094-.292.21h-4.388c0-.116-.131-.21-.293-.21h-7.021c-.162,0-.292.094-.292.21h-4.388c0-.116-.131-.21-.293-.21h-7.021c-.162,0-.293.094-.293.21h-4.388c0-.116-.131-.21-.292-.21h-7.021c-.162,0-.293.094-.293.21H575.6c0-.116-.131-.21-.292-.21h-7.021c-.162,0-.293.094-.293.21H563.6c0-.116-.131-.21-.292-.21h-55c-.162,0-.293.094-.293.21h-4.388c0-.116-.131-.21-.293-.21h-7.021c-.161,0-.293.094-.293.21h-4.388c0-.116-.131-.21-.293-.21h-7.021c-.162,0-.293.094-.293.21H479.64c0-.116-.131-.21-.293-.21h-7.021c-.162,0-.293.094-.293.21h-4.388c0-.116-.131-.21-.293-.21h-7.021c-.162,0-.293.094-.293.21H455.65c0-.116-.131-.21-.293-.21h-7.021c-.162,0-.293.094-.293.21h-4.388c0-.116-.131-.21-.293-.21h-7.021c-.162,0-.293.094-.293.21v2.115H422.592c-3.878,0-7.021,2.26-7.021,5.047V651.3c0,2.787,3.144,5.047,7.021,5.047H656.047c3.878,0,7.021-2.26,7.021-5.047v-2.282Z",
    transform: "translate(-316.107 -468.077)",
    fill: "#3e3e3e",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 77.574,
    height: 74.719,
    rx: 3.562,
    transform: "translate(225.819 85.706)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M325.241,254.187a48.123,48.123,0,0,1-.557,10.027s-3.9,8.913.557,12.812,12.812-11.7,12.812-11.7c-.578-3.461-.911-6.714,0-8.913Z",
    transform: "translate(-260.702 -235.915)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M342.614,526.6v12.255s-1.671,22.839,0,28.41l-.557,10.584h6.128l1.671-12.812s5.014-16.155,3.342-26.182l1.114-12.255Z",
    transform: "translate(-271.947 -399.144)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M304,526.6v12.255s1.671,22.839,0,28.41l.557,10.584h-6.127l-1.671-12.812s-5.013-16.155-3.342-26.182L292.3,526.6Z",
    transform: "translate(-242.244 -399.144)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M283.234,410.269s-3.342,21.168-1.114,33.423,2.228,16.155,2.228,16.155l13.926-.557,3.9-22.839,3.342,23.4,16.712-2.785s0-17.826.557-21.725.557-26.182.557-26.182Z",
    transform: "translate(-235.685 -328.772)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M346.637,651.873s-6.128-3.9-8.913,0v6.685s-2.228,5.013,5.571,3.9,5.013-5.013,5.013-5.013Z",
    transform: "translate(-269.285 -473.17)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M301.587,651.873s6.128-3.9,8.913,0v6.685s2.228,5.013-5.571,3.9-5.013-5.013-5.013-5.013Z",
    transform: "translate(-246.517 -473.17)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 8.913,
    cy: 8.913,
    r: 8.913,
    transform: "translate(62.868 6.016)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M317.62,285.184l-3.832-9.015-3.967,1.774-5.014,28.967.557,27.853s25.625-1.114,28.967.557-3.9-54.591-3.9-54.591l-3.342-4.169Z",
    transform: "translate(-249.739 -249.087)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M298.849,268.086s-8.471,2.228-8.471,5.571c0,0-8.356,1.671-8.356,3.342s-.557,44.007-.557,44.007-5.013,9.47-1.114,17.269l-.557,4.456,11.141,1.114,7.8-68.518Z",
    transform: "translate(-234.194 -244.244)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M358.724,268.086s8.471,2.228,8.471,5.571c0,0,8.356,1.671,8.356,3.342s.557,44.007.557,44.007,5.013,9.47,1.114,17.269l.557,4.456-11.141,1.114-7.8-68.518Z",
    transform: "translate(-282.045 -244.244)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M340.783,211.83s.557-2.228-2.228-1.114c0,0-3.342-3.9-6.685-1.114,0,0-6.685-1.114-6.685,4.456a53.009,53.009,0,0,1-.315,7.41s1.986-5.182,5.886-4.625a8.755,8.755,0,0,0,4.41-.215,3.343,3.343,0,0,1,2.334-.111,3.632,3.632,0,0,1,2.169,2,16.745,16.745,0,0,0,1.207,2.284,14.141,14.141,0,0,1,1.568,3.12h0l1.124-6.518s.557-3.342-1.114-4.456C342.454,212.945,343.011,211.273,340.783,211.83Z",
    transform: "translate(-261.76 -208.599)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 150.016,
    height: 48.872,
    transform: "translate(98.261 98.169)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M259.4,434.729s-3.342,12.812,1.671,11.7,3.9-12.255,3.9-12.255Z",
    transform: "translate(-221.874 -343.762)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M417.934,434.729s3.342,12.812-1.671,11.7-3.9-12.255-3.9-12.255Z",
    transform: "translate(-314.123 -343.762)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M271.238,288.534l-1.538-1.2s-1.8.083-2.362,1.2-9.47,28.967-9.47,28.967-2.785,14.483-1.114,23.4l.557,6.685h7.8L264.553,337l5.571-21.168Z",
    transform: "translate(-220.625 -255.779)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M393.758,288.534l1.538-1.2s1.8.083,2.362,1.2,9.47,28.967,9.47,28.967,2.785,14.483,1.114,23.4l-.557,6.685h-7.8L400.443,337l-5.571-21.168Z",
    transform: "translate(-303.037 -255.779)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 8.499,
    height: 8.499,
    transform: "translate(127.372 104.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 68.421,
    height: 0.85,
    transform: "translate(150.746 108.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 8.499,
    height: 8.499,
    transform: "translate(127.372 118.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 68.421,
    height: 0.85,
    transform: "translate(150.746 122.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 8.499,
    height: 8.499,
    transform: "translate(127.372 132.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 68.421,
    height: 0.85,
    transform: "translate(150.746 136.204)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1);
export default __webpack_public_path__ + "static/media/slide1.8fca33005008cb1bd8ca2def5711cc58.svg";
export { ForwardRef as ReactComponent };